import { RocheUIBadgeColor as e } from "../../badge/roche-badge.types.js";
var E = /* @__PURE__ */ ((o) => (o.ONCOLOGY_HEMATOLOGY = "oncology-hematology", o.OPHTHALMOLOGY = "ophthalmology", o.NEUROSCIENCE = "neuroscience", o.CARDIOVASCULAR = "cardiovascular", o.IMMUNOLOGY = "immunology", o.INFECTIOUS_DISEASES = "infectious-diseases", o.OTHER = "other", o))(E || {});
const l = {
  "oncology-hematology": e.ORANGE,
  ophthalmology: e.BLUE,
  neuroscience: e.YELLOW,
  cardiovascular: e.GREEN,
  immunology: e.PURPLE,
  "infectious-diseases": e.NEUTRAL,
  other: e.GREY
};
export {
  E as RocheUIPharmaCardVariant,
  l as rocheUIPharmaCardVariantBadgeColor
};
